import React from 'react';
import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let Polygon = (props) => (
  <SvgIcon {...props}>
    <path d="M18,5.06246443 L6,10.1967163 L6,8.01293945 L18,2.86164138 L18,0 L24,0 L24,6 L18,6 L18,5.06246443 Z M20.0072021,4 L22,4 L22,2 L20,2 L20,2.0030917 L20.0072021,2 L20.0072021,4 Z M18,18 L24,18 L24,24 L18,24 L18,18 Z M20,20 L20,22 L22,22 L22,20 L20,20 Z M0,7 L6,7 L6,13 L0,13 L0,7 Z M2,9 L2,11 L4,11 L4,9 L2,9 Z M0,18 L6,18 L6,24 L0,24 L0,18 Z M2,20 L2,22 L4,22 L4,20 L2,20 Z M20,6 L22,6 L22,18 L20,18 L20,6 Z M2,13 L4,13 L4,18 L2,18 L2,13 Z M6,20 L18,20 L18,22 L6,22 L6,20 Z"/>
  </SvgIcon>
);
Polygon = pure(Polygon);
Polygon.displayName = 'Polygon';
Polygon.muiName = 'SvgIcon';

export default Polygon;
